import React from "react"

function BottomCtaNavigation({
  currentSection,
  lastPage,
  center = false,
  inflight = false,
  nextDisabled = false,
  doneDisabled = false,
  nextLabel = "Next",
  doneLabel = "Done",
  previousLabel = "Previous",
  onNextStep,
  onPreviousStep,
  onDone,
  buttonType = "button",
}) {
  if (inflight) {
    return (
      <div className="bottom-cta d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  const isLast = currentSection === lastPage
  const showPrevious = currentSection !== 0

  return (
    <div className={`bottom-cta d-flex ${center ? "justify-content-center" : ""}`}>
      {showPrevious && (
        <button
          className="btn btn-light"
          type="button"
          onClick={onPreviousStep}>
          {previousLabel}
        </button>
      )}

      {isLast ? (
        <button
          className={`btn btn-main ${center ? "" : "ml-auto"}`}
          type={buttonType === "submit" ? "submit" : "button"}
          disabled={doneDisabled}
          onClick={onDone}>
          {doneLabel}
        </button>
      ) : (
        <button
          className={`btn btn-main ${center ? "" : "ml-auto"}`}
          type={buttonType === "submit" ? "submit" : "button"}
          disabled={nextDisabled}
          onClick={onNextStep}>
          {nextLabel}
        </button>
      )}
    </div>
  )
}

export default BottomCtaNavigation
